<template>
  <v-card
    elevation="12"
    rounded="lg"
    class="mb-4"
  >
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-toolbar
      flat
      dense
      color="color_green"
      dark
    >
      <v-toolbar-title>Timeseries Config</v-toolbar-title>
      <v-spacer />
      <span
        v-if="timeseriesConfig.updatedAt"
        class="caption mr-4"
      >
        Ultimo aggiornamento: {{ timeseriesConfig.updatedAt }}
      </span>
      <v-btn
        text
        @click="loadDefaultTimeseriesConfig"
      >
        Carica configurazione di default
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-card outlined>
        <v-card-title>Workspaces</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th style="min-width: 180px">ID</th>
                <th>Domain</th>
                <th>Resolution</th>
                <th>Priority</th>
                <th style="min-width: 160px">
                  Past
                </th>
                <th style="min-width: 160px">
                  Future
                </th>
                <th style="min-width: 220px">
                  Layers
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(ws, index) in workspaces"
                :key="index"
              >
                <td>
                  <v-text-field
                    v-model="ws.id"
                    dense
                    hide-details
                  />
                </td>
                <td>
                  <v-select
                    v-model="ws.domain_id"
                    :items="domainItems"
                    dense
                    hide-details
                  />
                </td>
                <td>
                  <v-text-field
                    v-model="ws.resolution"
                    dense
                    hide-details
                  />
                </td>
                <td>
                  <v-text-field
                    v-model.number="ws.priority"
                    type="number"
                    dense
                    hide-details
                  />
                </td>
                <td>
                  <v-checkbox
                    :input-value="ws.past === null"
                    label="Nessun limite"
                    dense
                    hide-details
                    @change="val => (ws.past = val ? null : 0)"
                  />
                  <v-text-field
                    v-if="ws.past !== null"
                    v-model.number="ws.past"
                    type="number"
                    dense
                    hide-details
                    suffix="h"
                  />
                </td>
                <td>
                  <v-checkbox
                    :input-value="ws.future === null"
                    label="Nessun limite"
                    dense
                    hide-details
                    @change="val => (ws.future = val ? null : 0)"
                  />
                  <v-text-field
                    v-if="ws.future !== null"
                    v-model.number="ws.future"
                    type="number"
                    dense
                    hide-details
                    suffix="h"
                  />
                </td>
                <td>
                  <v-combobox
                    v-model="ws.layers"
                    multiple
                    chips
                    deletable-chips
                    small-chips
                    dense
                    hide-details
                  />
                </td>
                <td>
                  <v-btn
                    icon
                    @click="removeWorkspace(index)"
                  >
                    <v-icon color="error">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-btn
            text
            color="color_green"
            class="mt-2"
            @click="addWorkspace"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            Aggiungi workspace
          </v-btn>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-spacer />
      <v-btn
        outlined
        color="color_green"
        :disabled="!isValid"
        @click="save"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      workspaces: []
    };
  },
  computed: {
    ...mapState(['timeseriesConfig', 'domain']),
    domainItems() {
      return this.domain.domains.map(d => ({
        text: d.domain_name,
        value: d.domain_id
      }));
    },
    isValid() {
      return (
        this.workspaces.length > 0 &&
        this.workspaces.every(ws => ws.id && ws.domain_id)
      );
    }
  },
  watch: {
    'timeseriesConfig.workspaces': {
      immediate: true,
      handler(workspaces) {
        this.workspaces = JSON.parse(JSON.stringify(workspaces));
      }
    }
  },
  async created() {
    this.loading = true;
    await Promise.all([this.storeTimeseriesConfig(), this.storeDomains()]);
    this.loading = false;
  },
  methods: {
    ...mapActions([
      'storeTimeseriesConfig',
      'loadDefaultTimeseriesConfig',
      'storeSaveTimeseriesConfig',
      'storeDomains'
    ]),
    addWorkspace() {
      this.workspaces.push({
        id: '',
        domain_id: (this.domain.domains[0] && this.domain.domains[0].domain_id) || null,
        resolution: 'hourly',
        priority: 1,
        past: 0,
        future: 0,
        layers: []
      });
    },
    removeWorkspace(index) {
      this.workspaces.splice(index, 1);
    },
    async save() {
      this.loading = true;
      await this.storeSaveTimeseriesConfig({
        workspaces: this.workspaces
      });
      this.loading = false;
    }
  }
};
</script>
